import AsyncSelect from '../Select/AsyncSelect';
import React, { useState } from 'react';
import { SelectValue } from '../Select/Select';
import apiClient from '../../../Services/ApiClient';
import { TERM_ITEMS } from '../../../Modules/Term/termItems.graphql';
import useTranslation from '../../../Hooks/useTranslation';
import { TermItem, useLazyTermItemsQuery } from '../../../graphql/graphql';
import { FieldError } from 'react-hook-form';

interface DiagnosisSelectProps {
	onChange?: (value: SelectValue) => void;
	value?: any;
	placeholder?: string;
	portal?: boolean;
	error?: FieldError;
}

const DiagnosisSelect: React.FC<DiagnosisSelectProps> = ({
	onChange,
	value,
	placeholder,
	portal = true,
	error,
}) => {
	const { t } = useTranslation();
	const [getTermItems] = useLazyTermItemsQuery();

	const [searchTimeout, setSearchTimeout] = useState<number | undefined>(
		undefined,
	);

	const loadOptions = (
		inputValue: string,
		callback: (options: SelectValue[]) => void,
	) => {
		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}

		const loadData = async () => {
			const { termItems } = await getTermItems({
				termType: 'diagnosis',
				fullText: inputValue,
				take: 20,
			}).unwrap();

			const t: SelectValue[] = [];

			// @ts-ignore
			(termItems?.data || []).forEach((termItem: TermItem) => {
				if (termItem.name) {
					t.push({
						label: termItem.value + ' - ' + termItem.name,
						value: termItem.value ?? termItem.id,
					});
				}
			});

			callback(t);
		};

		setSearchTimeout(
			setTimeout(() => {
				loadData();
			}, 500),
		);
	};

	const handleChange = (val: SelectValue) => {
		onChange?.(val);
	};

	return (
		<AsyncSelect
			onSearch={loadOptions}
			onChange={handleChange}
			placeholder={placeholder || t('base.shared.pick')}
			noOptionsMessage={t('base.startTyping')}
			value={value}
			portal={portal}
			error={error}
		/>
	);
};

export default DiagnosisSelect;
